import { motion } from "framer-motion";
import React from "react";
import { SafeArea } from "~/design-system/SafeArea";
import { Box } from "../../Box";

function MapSkeleton() {
  return (
    <motion.div
      style={{
        alignItems: "flex-start",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        justifyContent: "flex-start",
        width: "100%",
      }}
      initial={{ opacity: 0.4 }}
      animate={{ opacity: 0.8 }}
      transition={{
        duration: 0.6,
        ease: "easeIn",
        repeat: Infinity,
        repeatType: "mirror",
      }}
    >
      <SafeArea top />

      <Box
        css={{
          backgroundImage: `url("/map-placeholder.png")`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "100%",
          width: "100%",
        }}
      ></Box>
    </motion.div>
  );
}

export { MapSkeleton };
